/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { toolsAnalyticGroups, icons } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import { useAppDispatch } from 'app/hooks';
import { getUserId } from 'utils/sessionStorage';

// Menu for Student only
export default function ToolsAnalyticsList() {
  const dispatch = useAppDispatch();
  let history = useHistory();
  let location = useLocation();
  const [open, setOpen] = React.useState<string | null>(null);
  let studentId = getUserId();
  //let token = Cookies.get(authenticateSettings.tokenName);
  
  useEffect(() => {
    toolsAnalyticGroups.forEach((route: any) => {
      if (
        route.children.find((e: any) => location?.pathname?.includes(e?.path?.replace('/:id', '')))
      ) {
        setOpen(route.name);
      }
    });
  }, [location]);

  // const handleLogout = () => {
  //   dispatch(logout());
  //   history.replace(routers.login.path);
  // };

  const handleClick = (route: any) => {
    if (open === route.name) return setOpen(null);
    setOpen(route.name);
    if (route.isGroup === false) {
      history.push(route.route.path);
    }
  };

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        height: '100%',
        overflow: 'auto',
      }}
      component="nav"
      subheader={
        <ListSubheader component="div" className="text-field-light text-center">
          {/* All changes saved <SaveOutlinedIcon fontSize="small" /> */}
        </ListSubheader>
      }
    >
      {toolsAnalyticGroups.map((route: any, index: any) => {
        const IconBefore = icons[route.icon] || 'Component';
        return (
          <div key={index}>
            <ListItemButton
              onClick={() => handleClick(route)}
              className={`px-1 my-1 ${open === route.name && 'bg-light fw-bold'}`}
            >
              <IconBefore fontSize="small" className="me-2 text-secondary" />
              <span className="text-field-mid">{route.name}</span>
              {route.isGroup &&
                (open === route.name ? (
                  <ExpandLess fontSize="small" className="text-field-light" />
                ) : (
                  <ExpandMore fontSize="small" className="text-field-light" />
                ))}
            </ListItemButton>
            {route.isGroup && (
              <Collapse in={open === route.name} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {route.children.map((child: any, i: number) => {
                    return (
                      <ListItemButton
                        key={i}
                        sx={{ pl: 2, pt: 2 }}
                        onClick={() => history.push(child?.path.replace(':id', studentId))}
                        disabled={false}
                      >
                        <span className="text-secondary">{child?.icon}</span>
                        <span
                          className={
                            location.pathname.includes(child?.path.replace(':id', ''))
                              ? 'text-primary fw-bold'
                              : 'text-field-mid'
                          }
                        >
                          {child?.name}
                        </span>
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            )}
          </div>
        );
      })}
    </List>
  );
}
